


























































































































import { Component, Watch, Prop, Vue, Mixins } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { NumberRule, fomatLocaletoArray } from "@root/lib/common";
import { ProductChildren } from "@root/lib/mixins";
import multiLangEnter from "@/components/pages/ProductCreate/multiLangEnter.vue";
import editMultiLanguage from "@/components/pages/ProductCreate/editMultiLanguage.vue";
import dynamicLoadSelect from "@/components/pages/Product/dynamicLoadSelect.vue";
import selectTree from "./selectTree.vue";
import { FormVaildateToOut } from "@root/lib/decorator";
const productCreate = namespace("productCreate");
const Root = namespace("root");
@Component({
  components: {
    multiLangEnter,
    editMultiLanguage,
    dynamicLoadSelect,
    selectTree
  }
})
@FormVaildateToOut("form", {
  resCbName: "resFormart"
})
export default class BasicInfo extends Mixins(ProductChildren) {
  @Root.State languageList;
  @Root.State permission;
  @Prop({ default: false }) isEdit!: boolean;
  @Prop({ default: false }) readonly;

  get msg() {
    return this.$t("Basic.required_msg");
  }
  NumRule = null;
  get rules() {
    return {
      productNo: [
        {
          required: true,
          message: this.$t("Basic.required_msg"),
          trigger: "blur"
        },

        {
          pattern: /^[0-9a-zA-Z-]{1,50}$/,
          trigger: "blur",
          message: this.$t("Product.required_50_char_num_let")
        }
      ],
      productName: [
        {
          required: true,
          message: this.msg,
          trigger: "blur",
          validator: this.productNameValidate
        }
      ],
      extCode: [
        {
          pattern: /^[0-9a-zA-Z-]{1,50}$/,
          trigger: "blur",
          message: this.$t("Product.required_50_char_num_let")
        }
      ],
      barcode: [
        {
          pattern: /^[0-9a-zA-Z-]{1,20}$/,
          trigger: "blur",
          message: this.$t("Product.required_20_char_num_let")
        }
      ],
      brandCode: [{ required: true, message: this.msg, trigger: "blur" }],
      productPrice: [
        { required: true, validator: this.NumRule, trigger: "blur" }
      ],
      salePrice: [{ required: true, validator: this.NumRule, trigger: "blur" }],
      productType: [
        {
          required: true,
          trigger: "blur",
          message: this.$t("Basic.required_msg")
        }
      ],
      categoryCodeList: [
        {
          required: true,
          trigger: "change",
          message: this.$t("Basic.required_msg")
        }
      ],
      sort: [
        {
          trigger: "blur",
          validator: this.validateSort
        }
      ]
    };
  }
  allInfo = {};

  parmary: any = {
    PageInput: {
      pageNum: 1,
      pageSize: 100
    },
    condition: {
      locale: localStorage.getItem("localeLanguage"),
      channel: localStorage.getItem("channel"),
      orgCode: "default",
      conditionList: [[]]
    }
  };
  input1: string = "";

  ruleForm: any = {
    productCode: "",
    productNo: "",
    productName: "",
    extCode: "",
    barcode: "",
    brandCode: "",
    productPrice: "",
    orgCode: "",
    salePrice: null,
    productType: "",
    categoryCodeList: [],
    sort: ""
  };

  checkedData: any = [];
  loading: boolean = false;
  editMultKey = "productName";
  productNameLocales = {};
  curLocale = localStorage.getItem("localeLanguage");

  get typeOptions() {
    return [
      {
        label: this.$t("Product.delivery_product"),
        value: "0"
      },
      {
        label: this.$t("Product.service_product"),
        value: "1"
      },
      {
        label: this.$t("Product.virtual_product"),
        value: "2"
      }
    ];
  }
  defaultBrand = "";

  @productCreate.Getter propertiesData;
  @productCreate.State productInfo;
  @Watch("propertiesData")
  onPropertiesDataChange(val, oldVal) {
    this.ruleForm = {
      ...val,
      categoryCodeList: val.categoryCodeList.map(item => item.categoryCode)
    };
    this.defaultBrand = this.ruleForm.brandCode;
    this.initNameLocales();
  }
  @Watch("languageList")
  watchlanguageList(val) {
    this.initNameLocales();
  }
  initNameLocales() {
    let multi = this.productInfo.extendParams
      ? JSON.parse(this.productInfo.extendParams)
      : {};
    let { productName } = multi;
    if (productName && productName["[AC]"]) {
      this.productNameLocales = productName["[AC]"];
    }
    this.languageList.forEach((item, index) => {
      if (!this.productNameLocales[item.value]) {
        this.$set(
          this.productNameLocales,
          item.value,
          index === 0 ? this.propertiesData.productName : ""
        );
      }
    });
  }

  @productCreate.Action updateProduct;
  @productCreate.Action queryProductInfo;
  created() {
    this.NumRule = NumberRule.bind(this);
  }
  handleSubmit() {
    const $form: any = this.$refs.form;
    $form.validate(valid => {
      if (valid) {
        this.loading = true;
        this.save();
      }
    });
  }
  async save(): Promise<void> {
    const categoryCodeList = this.ruleForm.categoryCodeList.map(item => {
      return { categoryCode: item };
    });
    let localeList =
      fomatLocaletoArray(
        this.languageList,
        this.productNameLocales,
        "productName"
      ) || [];
    if (this.isEdit) {
      try {
        await this.updateProduct({
          ...this.ruleForm,
          categoryCodeList,
          localeList,
          sort: parseInt(this.ruleForm.sort) || 0
        });
        await this.getNewData();
        let message: any = this.$t("Basic.success");
        this["$message"].success(message);
        this.loading = false;
      } catch {
        this.loading = false;
      }
    } else {
      localStorage.setItem(
        "propertiesData",
        JSON.stringify({
          ...this.ruleForm,
          categoryCodeList,
          sort: parseInt(this.ruleForm.sort) || 0,
          localeList
        })
      );
      this.$emit("next");
    }
  }
  resFormart() {
    const categoryCodeList = this.ruleForm.categoryCodeList.map(item => {
      return { categoryCode: item };
    });
    let localeList =
      fomatLocaletoArray(
        this.languageList,
        this.productNameLocales,
        "productName"
      ) || [];
    return {
      ...this.ruleForm,
      categoryCodeList,
      localeList,
      sort: parseInt(this.ruleForm.sort) || 0
    };
  }
  async getNewData() {
    let res = await this.queryProductInfo(this.propertiesData.productCode);
  }
  // 编辑productName多语言
  curEditOption: any = "";
  editMultiOption() {
    const $edit: any = this.$refs.multiOptionDialog;
    $edit.dialogVisible = true;
  }
  saveMultiOption(data) {
    this.productNameLocales = { ...data };
    this.ruleForm.productName = data[this.curLocale];
    const $edit: any = this.$refs.form;
    $edit.validateField("productName");
  }

  isAllMultiLang() {
    return this.languageList.every(_ => {
      let value = this.productNameLocales[_.value];
      return !!value;
    });
  }
  productNameValidate(rule, value, callback) {
    let all = this.isAllMultiLang();
    if (!value || !all) {
      callback(new Error());
    }
    callback();
  }

  validateSort(rule, value, callback) {
    let val = Number(value);
    let regExp = /^(-[1-9])?\d*$/;
    if (value) {
      if (!regExp.test(value)) {
        let info: any = this.$t("Basic.num_be_init");
        callback(new Error(info));
      } else {
        callback();
      }
    } else {
      callback();
    }
  }

  changeBrand(data) {
    this.ruleForm.brandCode = data;
  }
}
